export const i18nConfig = {
    en: {
        email: "en@mail.com",
    },
    "en-premier": {
        email: "en-premier@mail.com",
    },
};
